/**
 * AT Header Mega Menu — hover (masaüstü) + dokunma/tıklama (tablet)
 */
(function () {
  const CLOSE_DELAY = 150;
  const COARSE = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function init() {
    document.querySelectorAll('.at-hmega__item--has-panel').forEach((item) => {
      const trigger = item.querySelector('.at-hmega__trigger');
      const panel = item.querySelector('.at-hmega__panel');
      if (!trigger || !panel) return;

      let closeTimer;

      function open() {
        clearTimeout(closeTimer);
        document.querySelectorAll('.at-hmega__item--has-panel.is-open').forEach((other) => {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        closeTimer = setTimeout(() => {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }

      function closeNow() {
        clearTimeout(closeTimer);
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (!COARSE) {
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);
        panel.addEventListener('mouseenter', open);
        panel.addEventListener('mouseleave', close);
      }

      trigger.addEventListener('click', (e) => {
        if (COARSE || window.innerWidth < 990) return;
        e.preventDefault();
        if (item.classList.contains('is-open')) closeNow();
        else open();
      });

      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('is-open')) closeNow();
          else open();
        }
        if (e.key === 'Escape') closeNow();
      });

      document.addEventListener(
        'click',
        (e) => {
          if (!item.classList.contains('is-open')) return;
          if (item.contains(e.target)) return;
          closeNow();
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
